export default "__VITE_ASSET__BWGUSk9H__"